export default "__VITE_ASSET__CgJEY3wI__"